import PropTypes from 'prop-types'
import { Trash } from '@styled-icons/boxicons-solid'
import Tooltip from '../../../../common/tooltip'

const DtcDependencyRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-4/12 pl-10 items-center">
          <Tooltip message={props.name}>
            <div className="font-bold"> {props.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip message={props.description}>
            <div className=""> {props.description}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props.ecu}>
            <div className=""> {props.ecu}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 justify-end">
          <div>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <Trash size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

DtcDependencyRow.propTypes = {
  name: PropTypes.string.isRequired,
  ecu: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default DtcDependencyRow
